import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class newsletterTemplateColorsEdit_template extends vnTemplate {

    protected getTemplateHtml(): string {
        return `
            <div class="form-header">
                <h3 class="form-title">Header Color</h3>
                <button data-bind="event: { click: onClickCancelEdit }" class="close-button icon i-close-2" type="button"></button>
            </div>
            <div class="w-form-body">
                <div class="form-body">
                    <div class="form-group row">
                        <label for="name" class="form-label form-label form-label-box">Name</label>
                        <input type="text" class="input-text" data-bind="value: name">
                    </div>
                    <div class="form-group row">
                        <label class="form-label form-label form-label-box">Color</label>
                        <input type="color"
                               class="input-color"
                               aria-label="Header Color"
                               data-bind="value: color, event: { change: onColorPicked, input: onColorPicked }">
                        <span class="form-label" style="flex: none; margin-left: 10px;" data-bind="visible: !color()">Not set</span>
                    </div>
                </div>
            </div>
            <div class="form-footer">
                <button data-bind="event: { click: onClickCancelEdit }" class="btn" type="button">Cancel</button>
                <button data-bind="event: { click: onClickSave }" class="btn highlight" type="button">Save</button>
            </div>
        `;
    }

    protected getMainElementClasses(): Array<string> {

        return ["w-form"];
    }

    protected buildViewModel(): any {
        let self = this
        return {
            id: ko.observable(""),
            name: ko.observable(""),
            color: ko.observable(""),
            onColorPicked: function (data: any, event: any) {
                self.onColorPicked(event);
            },
            onClickCancelEdit: function (data: any, event: any) {
                self.onClickCancelEdit();
            },
            onClickSave: function (data: any, event: any) {
                self.onClickSave()
            }
        }
    }

    protected getTemplateName(): string {
        return "newsletterTemplateColorsEdit_template";
    }

    public getViewModelForRequest(): any {

        return {
            id: this.getTemplateViewModel().id(),
            name: this.getTemplateViewModel().name(),
            color: this.getTemplateViewModel().color(),
        }
    }

    protected onColorPicked(event: any): any {
        this.getTemplateViewModel().color(event.target.value);
    }

    public setHeaderColor(color: any): void {
        this.getTemplateViewModel().id(color.id);
        this.getTemplateViewModel().name(color.name);
        this.getTemplateViewModel().color(color.value);
    }

    protected onClickCancelEdit(): any {
        this.caller.onClickCancelEdit();
    }

    protected onClickSave(): any {
        this.caller.save()
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/newsletterTemplateColorsEdit_template.ts